<div class="work-ui-breadcrumb">
  @for (breadcrumb of breadcrumbs(); track $index; let last = $last) {
    @if (!last) {
      <p class="work-ui-breadcrumb__item">
        <a [routerLink]="[breadcrumb.route]"
           class="">
          @if (breadcrumb.icon) {
            <work-ui-icon [fontSize]="22" [name]="breadcrumb.icon" />
          }
          <span>{{ breadcrumb.label | translate }}</span>
        </a>
      </p>
    } @else if (!hideActiveBreadcrumb) {
      <p class="work-ui-breadcrumb__item">
        @if (breadcrumb.icon) {
          <work-ui-icon [fontSize]="22" [name]="breadcrumb.icon" />
        }
        <span><b>{{ breadcrumb.label | translate }}</b></span>
      </p>
    }
    @if (!last) {
      <work-ui-icon [fontSize]="20" name="arrow_forward_ios" />
    }
  }
</div>